import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
          <Lock className="w-3.5 h-3.5" /> [ admin · access ]
        </div>
        <h1 className="font-serif text-4xl tracking-tight">Sign in</h1>
        <p className="mt-3 text-muted-foreground text-sm">Restricted to Marcus. If you're not Marcus, please close this tab.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email-input"
              className="mt-2 w-full bg-transparent border-b border-border focus:border-foreground outline-none py-3 transition-colors"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password-input"
              className="mt-2 w-full bg-transparent border-b border-border focus:border-foreground outline-none py-3 transition-colors"
            />
          </div>
          <button
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full mt-4 py-3 rounded-full bg-foreground text-background font-mono text-xs uppercase tracking-[0.2em] disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in →"}
          </button>
        </form>
      </div>
    </div>
  );
}
